import React, { useState, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';

const WalletConnect = ({ onWalletConnected }) => {
  const [walletAddress, setWalletAddress] = useState('');
  const [isConnecting, setIsConnecting] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();

  // Verificar se já está conectado
  useEffect(() => {
    const savedWallet = localStorage.getItem('walletAddress');
    if (savedWallet) {
      setWalletAddress(savedWallet);
    }
  }, []);

  const connectWallet = async () => {
    setIsConnecting(true);
    setError('');

    try {
      // Verificar se MetaMask está instalado
      if (!window.ethereum) {
        throw new Error('MetaMask não encontrado! Instale a extensão.');
      }

      // Solicitar conexão com a carteira
      const accounts = await window.ethereum.request({
        method: 'eth_requestAccounts'
      });

      if (accounts.length === 0) {
        throw new Error('Nenhuma conta encontrada!');
      }

      const address = accounts[0];
      setWalletAddress(address);
      localStorage.setItem('walletAddress', address);

      // Fazer login no backend
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000'}/auth/wallet`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          walletAddress: address
        })
      });

      const data = await response.json();

      if (data.success) {
        // Login bem-sucedido
        login(data.profile, data.token);
        if (onWalletConnected) {
          onWalletConnected(data.profile);
        }
      } else {
        throw new Error(data.error || 'Erro ao conectar carteira');
      }

    } catch (error) {
      console.error('Erro ao conectar carteira:', error);
      setError(error.message);
      // Limpa em caso de erro
      setWalletAddress('');
      localStorage.removeItem('walletAddress');
    } finally {
      setIsConnecting(false);
    }
  };

  const disconnectWallet = () => {
    setWalletAddress('');
    setError('');
    localStorage.removeItem('walletAddress');
    
    // Remove listeners do MetaMask
    if (window.ethereum) {
      window.ethereum.removeAllListeners();
    }
    
    // Força recarregamento para limpar completamente
    window.location.reload();
  };

  // Se já está conectado, mostrar botão de desconectar
  if (walletAddress) {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-green-800 font-medium">Carteira Conectada</p>
            <p className="text-green-600 text-sm mt-1">
              {walletAddress.slice(0, 6)}...{walletAddress.slice(-4)}
            </p>
          </div>
          <button
            onClick={disconnectWallet}
            className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-sm"
          >
            Desconectar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-3">
        Conectar Carteira Web3
      </h3>
      
      <button
        onClick={connectWallet}
        disabled={isConnecting}
        className="w-full bg-purple-500 hover:bg-purple-600 disabled:bg-purple-300 text-white font-medium py-3 px-4 rounded-lg transition-colors flex items-center justify-center"
      >
        {isConnecting ? (
          <>
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
            Conectando...
          </>
        ) : (
          'Conectar com MetaMask'
        )}
      </button>

      {error && (
        <div className="mt-3 p-3 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-red-700 text-sm">{error}</p>
        </div>
      )}

      <p className="text-gray-500 text-sm mt-3">
        Conecte sua carteira Web3 para acessar recursos exclusivos
      </p>
    </div>
  );
};

export default WalletConnect;
